module.exports = __webpack_public_path__ + "assets/img/pair_ensemble_2.a500a642.svg";